import { useMemo } from "react";
import Pagination from "react-bootstrap/Pagination";

const LaravelPagination = (props) => {
    const pagination = useMemo(() => {
        const links = props?.links ?? [];
        const cpage = props?.current_page ?? 1;

        const handleClickNext = () => {
            props.onChangePage?.(cpage + 1);
        };

        const handleClickPrev = () => {
            props.onChangePage?.(cpage - 1);
        };

        const handleClickPage = (value) => {
            props.onChangePage?.(value);
        };

        return links.map((v, i) => {
            if (v?.label?.endsWith("Previous")) {
                return <Pagination.Prev key={i} active={v.active} disabled={!v.url} onClick={handleClickPrev} />;
            } else if (v?.label?.startsWith("Next")) {
                return <Pagination.Next key={i} active={v.active} disabled={!v.url} onClick={handleClickNext} />;
            } else {
                return <Pagination.Item key={i} active={v.active} disabled={!v.url} children={v?.label} onClick={() => handleClickPage(v?.label)} />;
            }
        });
    }, [props]);

    return <Pagination className="mb-0">{pagination}</Pagination>;
};

export default LaravelPagination;
